import React from 'react';
import {
  FillInTheBlanksPinProps,
  FillInTheBlanksPinReactComponent,
} from '../../../../pins/FillInTheBlanksPin/FillInTheBlanksPin';

export const FillInTheBlanksPinStatic: React.FC<FillInTheBlanksPinProps> = (props) => {
  return (
    <FillInTheBlanksPinReactComponent pinSettings={props.pinSettings} isThumb={props.isThumb}>
      {props.children}
    </FillInTheBlanksPinReactComponent>
  );
};
